import {modalAlert} from "../modules/modalAlert.js";
import {modalConfirm} from "../modules/modalConfirm.js";

import {APIRequest} from "../modules/APIRequest.js";

// Landing page: the admin login modal. Every login sends admin_only=1, so the
// server refuses non-admin accounts and tells them to use the app.
(async ()=>{

	const $modal = $("#adminLoginModal");
	const submitLabel = `<i class="fas fa-sign-in-alt"></i> Log In`;
	const waitLabel = `<i class="fas fa-sync fa-spin"></i> Please wait...`;
	var pending_login = false;

	// Open the modal directly with index.php#admin-login
	const openFromHash = ()=>{ if(location.hash === '#admin-login') $modal.modal('show'); };
	openFromHash();
	$(window).on('hashchange', openFromHash);
	$modal.on('shown.bs.modal', ()=>$("#login-email-input").trigger('focus'));

	function showError(message){
		$("#login-form-error").html('<i class="fas fa-exclamation-circle"></i> '+message).show();
	}

	function resetButton(){
		pending_login = false;
		$("#login-submit-btn").html(submitLabel).prop('disabled', false);
	}

	async function login(email, password, from_saved){
		var request = new APIRequest();
		request.set('login', 'email', email);
		request.set('login', 'password', password);
		request.set('login', 'admin_only', 1);
		// The server sets the JWT as an HttpOnly cookie (no PHP session); see includes/helpers/auth.php.
		request.set('login', 'cookie', 1);
		if(from_saved) request.set('login', 'from_ls', 1);
		request.set('login', 'device', JSON.stringify(await getAppDetails()));
		return (await request.send()).login;
	}

	$("#login-form").submit(async function(e){
		e.preventDefault();
		if(pending_login) return;
		pending_login = true;

		const email = $("#login-email-input").val().trim();
		const password = $("#login-password-input").val().trim();
		const remember = $("#remember-me-cb").is(':checked');

		$("#login-submit-btn").html(waitLabel).prop('disabled', true);
		$("#login-form-error").hide();

		var result = await login(email, password, false);

		if(!result.errors.length){
			if(remember) localStorage.setItem('mb-login', JSON.stringify([email, password]));
			location.href = "./dashboard.php";
			return;
		}

		resetButton();
		showError(result.errors.join(" "));

		// Inactive admin account: offer to resend the activation email.
		if(result.data && result.data.can_resend){
			$modal.modal('hide');
			var resend = await modalConfirm('<div class="alert alert-danger"><p>Your account is not active. Please click the link in the welcome email to activate your account. If you don\'t see the email, check your spam folder, otherwise, we can resend it for you.</p><p><b>Would you like us to resend the confirmation email?</b></p></div>', 'Resend Email?', 'Resend Email', 'Close');
			if(resend){
				var request = new APIRequest();
				request.set('resendConfirmationEmail', 'email', email);
				result = (await request.send()).resendConfirmationEmail;
				if(result.errors.length){
					await modalAlert('<div class="alert alert-danger">'+result.errors.join(" ")+'</div>', 'Error');
				}else{
					await modalAlert('<div class="alert alert-success">The confirmation email was resent. It may take a few minutes to arrive. If you don\'t see it in the next 6 hours, come back and we\'ll send it again.</div>', 'Success');
				}
			}
		}
	});

	// "Remember Me": log saved admins straight in.
	var saved = null;
	try{ saved = JSON.parse(localStorage.getItem('mb-login')); }catch(e){}
	if(!saved || !saved[0] || !saved[1]) return;

	pending_login = true;
	$("#login-submit-btn").html(waitLabel).prop('disabled', true);
	var result = await login(saved[0], saved[1], true);
	if(result.errors.length){
		localStorage.removeItem('mb-login');
		resetButton();
	}else{
		location.href = "./dashboard.php";
	}

	function getAppDetails(){
		var result = (new UAParser()).getResult();
		return Promise.resolve({
			cordova: '',
			model: result?.device?.model || '',
			platform: result?.os?.name || '',
			os_version: result?.os?.version || '',
			app_version: '',
			browser: result?.browser?.name || '',
			browser_version: result?.browser?.version || ''
		});
	}

})();
